import { render, staticRenderFns } from "./main-value.vue?vue&type=template&id=757f85a7&scoped=true&"
import script from "./main-value.vue?vue&type=script&lang=js&"
export * from "./main-value.vue?vue&type=script&lang=js&"
import style0 from "./main-value.vue?vue&type=style&index=0&id=757f85a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f85a7",
  null
  
)

export default component.exports